import React from 'react';
import img1 from '../images/img1.png';
import img2 from '../images/img2.png';
import { Link } from 'react-router-dom';
export const Advantages = () => {
  return (
    <section className="advantages-section">
      <div className="advantages-container container">
        <div className="advantage-1">
          <div className="advantage-img">
            <img src={img1} alt="wieprzowina puławska" />
          </div>
          <div className="advantages-text">
            <h2>Wieprzowina puławska</h2>
            <p>
              Mięso świń rasy puławskiej wyróżnia się bardzo dobrą jakością.
              Nawet po obróbce termicznej nie traci aromatu i ma
              charakterystyczny, marmurkowy wygląd co zawdzięcza odpowiedniemu
              udziałowi tłuszczy śródmięśniowego, który jest nośnikiem smaku i
              zapachu.
            </p>
            <button className="standard-btn">
              <Link to="/oferta">sprawdź nasze wyroby</Link>
            </button>
          </div>
        </div>
        <div className="advantage-2">
          <div className="advantage-img">
            <img src={img2} alt="tradycyjna specjalność" />
          </div>
          <div className="advantages-text">
            <h2>Gwarantowana tradycyjna specjalność</h2>
            <p>
              Zakład Mięsny Kwiecińscy jest małą rodzinną firmą. Zajmujemy się
              przetwórstwem i sprzedażą mięsa wieprzowego. Posiadamy sieć
              własnych sklepów firmowych, również zaopatrujemy szkoły i
              restauracje. Ponad ćwierć wieku istnienia zaowocowało stworzeniem
              wielu własnych, niepowtarzalnych receptur i uznaniem wśród naszych
              klientów. Cenimy sobie najwyższą jakość oferowanych przez nas
              produktów, dlatego zaopatrujemy się w żywiec tylo od lokalnych
              hodowców, a regularny ubój jest gwarancją świeżości naszych
              towarów.
            </p>
            <button className="standard-btn">
              <Link to="/oferta">sprawdź nasze produkty</Link>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
